/**
 * A channel's post type as the code compares it.
 *
 * The composer stores the type by its id in the rules table ('Thread',
 * 'Reel', 'Carousel'); the public API and older posts send it in lower case
 * ('thread', 'reel'). Every comparison goes through here, so the API (X
 * credits, the formatter), the worker (how it publishes) and the web (the
 * preview and the credit counter) read the same post the same way.
 */

/** The post type trimmed and in lower case; '' when there is none. */
export function normalizePostType(postType: string | null | undefined): string {
  return typeof postType === 'string' ? postType.trim().toLowerCase() : '';
}

/** Whether `postType` is `expected`, whatever its case ('Thread' is 'thread'). */
export function isPostType(postType: string | null | undefined, expected: string): boolean {
  return normalizePostType(postType) === normalizePostType(expected);
}

/** Whether an X post is a thread: its text is split into several posts. */
export function isXThread(postType: string | null | undefined): boolean {
  return isPostType(postType, 'thread');
}
